import { useEffect, useState, useRef } from "react";
import { api, API } from "../lib/api";
import { Upload, X, ImageIcon } from "lucide-react";
import { toast } from "sonner";

export default function RepairPhotos({ repairId }) {
  const [photos, setPhotos] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [lightbox, setLightbox] = useState(null);
  const fileInputRef = useRef(null);
  const [kind, setKind] = useState("before");

  const load = async () => {
    const r = await api.get(`/admin/repairs/${repairId}/photos`);
    setPhotos(r.data);
  };
  useEffect(() => { load(); }, [repairId]);

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append("file", file);
        await api.post(`/admin/repairs/${repairId}/photos?kind=${kind}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      } catch (err) { toast.error(`Eroare la ${file.name}: ${err.response?.data?.detail || ""}`); }
    }
    setUploading(false);
    e.target.value = "";
    load();
    toast.success("Poze incarcate");
  };

  const remove = async (id) => {
    if (!confirm("Sterge poza?")) return;
    await api.delete(`/admin/photos/${id}`);
    load();
  };

  const token = localStorage.getItem("kk_token");
  const photoUrl = (p) => `${API}/files/${p.storage_path}?auth=${token}`;

  const KIND_RO = { before: "Inainte", after: "Dupa", general: "General" };

  return (
    <div data-testid="repair-photos">
      <div className="flex items-center gap-2 mb-3 flex-wrap">
        <div className="text-xs uppercase tracking-widest text-[#00E5FF] font-bold">Poze ({photos.length})</div>
        <div className="ml-auto flex items-center gap-1">
          {["before", "after", "general"].map((k) => (
            <button key={k} onClick={() => setKind(k)} className={`text-[10px] uppercase tracking-widest px-2 py-1 border ${kind === k ? "bg-[#00E5FF] text-black border-[#00E5FF]" : "border-neutral-700 text-neutral-400 hover:border-[#00E5FF]"}`}>
              {KIND_RO[k]}
            </button>
          ))}
          <button onClick={() => fileInputRef.current?.click()} disabled={uploading} data-testid="upload-photo-btn" className="ml-1 bg-[#00E5FF] hover:bg-[#5CEEFF] text-black text-xs font-semibold uppercase tracking-wider px-3 py-1.5 inline-flex items-center gap-1">
            <Upload className="w-3.5 h-3.5" /> {uploading ? "..." : "Upload"}
          </button>
          <input ref={fileInputRef} type="file" accept="image/*" multiple onChange={handleUpload} className="hidden" />
        </div>
      </div>

      {photos.length === 0 ? (
        <div className="border border-dashed border-neutral-800 p-6 text-center text-xs text-neutral-500 flex flex-col items-center gap-2">
          <ImageIcon className="w-6 h-6" />
          Nicio poza inca. Adauga {KIND_RO[kind].toLowerCase()}.
        </div>
      ) : (
        <div className="grid grid-cols-4 sm:grid-cols-6 gap-2">
          {photos.map((p) => (
            <div key={p.id} className="relative group aspect-square border border-neutral-800 hover:border-[#00E5FF] overflow-hidden">
              <img src={photoUrl(p)} alt={p.kind} className="w-full h-full object-cover cursor-pointer" onClick={() => setLightbox(p)} />
              <div className="absolute top-0 left-0 bg-[#00E5FF] text-black text-[8px] uppercase tracking-widest px-1 py-0.5">{KIND_RO[p.kind]}</div>
              <button onClick={() => remove(p.id)} className="absolute top-1 right-1 bg-black/60 hover:bg-red-500 text-white p-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
                <X className="w-3 h-3" />
              </button>
            </div>
          ))}
        </div>
      )}

      {lightbox && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4" onClick={() => setLightbox(null)}>
          <img src={photoUrl(lightbox)} alt="full" className="max-w-full max-h-full object-contain" />
          <button onClick={() => setLightbox(null)} className="absolute top-4 right-4 text-white bg-neutral-900 p-2"><X className="w-5 h-5" /></button>
        </div>
      )}
    </div>
  );
}
